<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Buscar Pessoa' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido">
    <ion-searchbar
      show-cancel-button="never"
      class="custom"
      (ionCancel)="onCancel()"
      placeholder="{{'Buscar Pessoa' | translate}}"
      [(ngModel)]="filtro"
      (ionInput)="onInput()"
    >
    </ion-searchbar>
  </div>

  <ion-grid>
    <ion-row *ngFor="let a of pessoaList;">
      <ion-col
        (press)="selecionarPessoa(a);"
        [ngClass]="{'selecionado': a.selecionado}"
        (click)="selecionar(a);"
        class="remove-border"
      >
        <ion-item class="avatar-square no-border">
          <ion-avatar slot="start" class="avatar-image">
            <img [src]="a.foto | image:' '" />
          </ion-avatar>

          <ion-label class="item-content">
            <h3 class="item-title bold-2">{{a.nome}}</h3>

            <div class="item-description">
              <p class="description-text">{{a.funcoes}}</p>
            </div>
          </ion-label>

          <ion-note slot="end">
            <i class="fa-regular fa-chevron-right icon-list"></i>
          </ion-note>
        </ion-item>
      </ion-col>
    </ion-row>

    <sem-registro [hidden]="pessoaList.length"> </sem-registro>
  </ion-grid>
  <ion-infinite-scroll class="ion-margin-top" (ionInfinite)="loadPessoas($event)" *ngIf="pagination.currentPage < pagination.pageCount">
    <ion-infinite-scroll-content loadingText="{{'Carregando' | translate}}..."> </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
